import type { ThemeColors } from '../contexts/ThemeContext'

export function mapExplorerThemeToAppColors(
  vars: Record<string, string>,
  isDark: boolean,
): ThemeColors {
  const primary = vars['--t-primary'] ?? '#0ea5e9'
  const primarySoft = vars['--t-primary-soft'] ?? '#f0f9ff'
  const accent = vars['--t-accent'] ?? '#0284c7'
  const bg = vars['--t-bg'] ?? '#f8fafc'
  const fg = vars['--t-fg'] ?? '#334155'
  const muted = vars['--t-muted'] ?? '#64748b'
  const card = vars['--t-card'] ?? '#ffffff'
  const border = vars['--t-border'] ?? '#e2e8f0'
  const sidebarBg = vars['--t-sidebar-bg'] ?? '#ffffff'
  const sidebarFg = vars['--t-sidebar-fg'] ?? '#475569'
  const sidebarBorder = vars['--t-sidebar-border'] ?? border
  const headerBg = vars['--t-header-bg'] ?? card
  const danger = vars['--t-danger'] ?? '#dc2626'

  return {
    primary,
    primaryHover: accent,
    primaryLight: primarySoft,
    buttonPrimary: primary,
    buttonPrimaryHover: accent,
    buttonSecondary: isDark ? border : primarySoft,
    buttonSecondaryHover: isDark ? muted : border,
    cardBackground: card,
    cardBorder: border,
    textPrimary: fg,
    textSecondary: muted,
    inputPlaceholder: muted,
    formRequiredColor: danger,
    inputBackground: isDark ? card : '#ffffff',
    background: bg,
    sidebarBackground: sidebarBg,
    border,
    tableHeaderBackground: isDark ? card : bg,
    tableHeaderText: muted,
    tableRowBackground: card,
    tableRowHover: isDark ? border : primarySoft,
    tableBorder: border,
    navHeaderBackground: headerBg,
    navHeaderText: fg,
    navHeaderBorder: border,
    sidebarActiveBackground: primarySoft,
    sidebarActiveText: primary,
    sidebarHoverBackground: primarySoft,
    sidebarHoverText: primary,
    sidebarText: sidebarFg,
    sidebarBorder,
  }
}
